const resizePushCode = `
    if robcratchNewSize.X > robcratchPreviousSize.X or robcratchNewSize.Y > robcratchPreviousSize.Y or robcratchNewSize.Z > robcratchPreviousSize.Z then
      local robcratchOverlapParams = OverlapParams.new()
      robcratchOverlapParams.FilterType = Enum.RaycastFilterType.Exclude
      robcratchOverlapParams.FilterDescendantsInstances = { robcratchPart }

      local robcratchPartRoot = robcratchPart.AssemblyRootPart or robcratchPart
      local robcratchPartPosition = robcratchPart.Position
      local robcratchPartRadius = math.max(robcratchNewSize.X, robcratchNewSize.Z) / 2
      local robcratchMovedTargets = {}

      for _, robcratchOtherPart in ipairs(workspace:GetPartsInPart(robcratchPart, robcratchOverlapParams)) do
        if robcratchOtherPart:IsA("BasePart") and not robcratchOtherPart:IsDescendantOf(robcratchPart) then
          local robcratchOtherRoot = robcratchOtherPart.AssemblyRootPart or robcratchOtherPart

          if robcratchOtherRoot ~= robcratchPartRoot then
            local robcratchModel = robcratchOtherPart:FindFirstAncestorOfClass("Model")
            local robcratchHumanoid = nil
            local robcratchMovePart = robcratchOtherRoot

            if robcratchModel then
              robcratchHumanoid = robcratchModel:FindFirstChildOfClass("Humanoid")
              local robcratchHumanoidRootPart = robcratchModel:FindFirstChild("HumanoidRootPart")
              if robcratchHumanoid and robcratchHumanoidRootPart and robcratchHumanoidRootPart:IsA("BasePart") then
                robcratchMovePart = robcratchHumanoidRootPart
              end
            end

            local robcratchMoveKey = robcratchHumanoid and robcratchModel or robcratchMovePart
            if robcratchMovePart and not robcratchMovePart.Anchored and not robcratchMovedTargets[robcratchMoveKey] and (robcratchHumanoid or robcratchOtherPart.CanCollide) then
              local robcratchOffset = robcratchMovePart.Position - robcratchPartPosition
              local robcratchDirection = Vector3.new(robcratchOffset.X, 0, robcratchOffset.Z)

              if robcratchDirection.Magnitude < 0.001 then
                robcratchDirection = Vector3.new(robcratchPart.CFrame.LookVector.X, 0, robcratchPart.CFrame.LookVector.Z)
              end
              if robcratchDirection.Magnitude < 0.001 then
                robcratchDirection = Vector3.new(1, 0, 0)
              end

              local robcratchTargetSize = robcratchMovePart.Size
              if robcratchHumanoid and robcratchModel then
                local _, robcratchModelSize = robcratchModel:GetBoundingBox()
                robcratchTargetSize = robcratchModelSize
              end

              local robcratchTargetRadius = math.max(robcratchTargetSize.X, robcratchTargetSize.Z) / 2
              local robcratchMinimumDistance = robcratchPartRadius + robcratchTargetRadius + 0.05
              local robcratchHorizontalDistance = robcratchDirection.Magnitude

              if robcratchHorizontalDistance < robcratchMinimumDistance then
                local robcratchMovement = robcratchDirection.Unit * (robcratchMinimumDistance - robcratchHorizontalDistance)

                if robcratchHumanoid and robcratchModel then
                  robcratchModel:PivotTo(robcratchModel:GetPivot() + robcratchMovement)
                else
                  robcratchMovePart.CFrame = robcratchMovePart.CFrame + robcratchMovement
                end

                robcratchMovedTargets[robcratchMoveKey] = true
              end
            end
          end
        end
      end
    end
`

export const resizeParentCode = (newSizeExpression: string) => `do
  local robcratchPart = script.Parent
  if robcratchPart:IsA("BasePart") then
    local robcratchPreviousSize = robcratchPart.Size
    local robcratchNewSize = ${newSizeExpression}

    robcratchPart.Size = robcratchNewSize

    if robcratchPart.CanCollide then
${resizePushCode}    end
  end
end\n`
